export const DEFAULT_CATERGORY_SLUG = "trending";

export const MASTER_COMPANY_TYPENAME = "MasterCompany";
export const CUSTOMER_CASE_STUDY_SLUG = "customer-case-studies";
export const ALL_TEMPLATES = "All Templates";
